import { Component } from '@angular/core';
import { SchoolbelleService } from '@schoolbelle/api/schoolbelle';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalsComponent } from '../modals.component';

@Component({
  selector: 'app-agreement-show',
  templateUrl: './agreement-show.component.html',
  styleUrls: ['./agreement-show.component.css']
})
export class AgreementShowComponent extends ModalsComponent {

  constructor(
    private sbe : SchoolbelleService,
    modalRef : BsModalRef,
  ) {
    super(modalRef)
  }

  privacyPolicy;
  termsOfUse; 
  agreedToTermsOfUse = false;
  agreedToPrivacyPolicy = false;
  showAgreedToTermsOfUse = true;
  showAgreedToPrivacyPolicy = true;
  ngOnInit() : void {
    this.sbe.getPrivacyPolicy().subscribe(privacyPolicy=>this.privacyPolicy =privacyPolicy);
    this.sbe.getTermsOfUse().subscribe(termsOfUse=>this.termsOfUse = termsOfUse);
  }
}
